import React from "react";

function Footer() {
  return (
    <div className="footer">
      <div className="office">
        <h2>Office:</h2>
        <p>
          SF Sonic Batteries,
          <br /> 59E, Chowringhee Road
          <br /> Bikaner - 334001 Rajasthan
          <br /> Call Us : +91 9521271856
          <br /> Email : karnibatteries@gmail.com
        </p>
      </div>
    </div>
  );
}

export default Footer;
